import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  statusCode: number
  errorCode?: string
  errorMessage?: string
}

const PermissionsBanner = ({ statusCode, errorCode, errorMessage }: Props) => {
  const backgroundColor = 'radicalRed100'
  const icon = 'alert-circle-line'
  const noPermissions: boolean = statusCode !== 200 || !!errorCode === true

  const description = () => {
    if (statusCode === 403 || isNaN(statusCode)) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_permissions'
      )
    } else if (statusCode === 504) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_rz_komm_subscription'
      )
    } else if (errorMessage?.toLowerCase().includes('client is not activated for data exchange')) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.not_activated_for_data_exchange'
      )
    } else if (errorCode === '#DCO02401') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.not_enabled_lohnaustauschdatenservice'
      )
    } else if (errorCode === '#DCO02431') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_rz_komm_subscription'
      )
    } else {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.other_errors'
      )
    }
  }

  return (
    <>
      {noPermissions && (
        <Box
          flexDirection="column"
          justifyContent="flexStart"
          padding="s24"
          borderRadius={{ all: 'abs016' }}
          background={backgroundColor}
          gap="s8"
        >
          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Icon.Medium icon={icon} color="radicalRed1000" />
            <Text size="200" weight="bold">
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.title'
              )}
            </Text>
          </Box>

          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Text size="200">{description()}</Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default PermissionsBanner
